import profile from "./images/user.png"
const testinomials = [
    {
        desc:"I have studied in Dhoot Physics Academy for 2 years. The teaching of Dhoot sir is great. He is very friendly and has their focus on each and every student. Dhoot sir provides all the study material and questions on each topics which helps in understanding the concepts of the topic. It was a very good experience of studying under you. Thank you sir.",
        name:"Sahil Ade",
        img:profile
    },
    {
        desc:"Dhoot Physics Academy.Four walls, a building with a future inside. I received the most effective learning experience here.Looking forward to achieve success under your guidance.",
        name:"Trisha Patel",
        img:profile
    },
    {
        desc:"Santosh Dhoot sir gives individual attention to all students and helps them to improvise on their weak areas for sure shot success in NEET/JEE.",
        name:"Arjun Kulkarni",
        img:profile
    },
    {
        desc:"It's the only class I have joined which has the perfect study environment.I used to find physics as a really difficult subject but , now I am able to understand each and every concept clearly. This year the top score in NEET is 160 , and I aim and look forward to 180 with Dhoot sir's guidance. ",
        name:"Anandi  Khadke",
        img:profile
    },
    {
        desc:"Dhoot sir is a very thoughtful teacher..he makes understanding physics fun..I look forward to score well in future by the guidance of Dhoot sir.",
        name:"Riddhi Patel",
        img:profile
    }
];

export default testinomials;